import { environment } from '@env/environment';

export const CONSTANSTS = {
    api: {
        config: environment.apiUrl + '/api/ConfigParameters/GetConfigParameters',
        // giriş-şifremi unuttum ve yeni üyelik;
        default: {
            login: environment.apiUrl + '/api/Default/CheckUser',
            avatar: environment.apiUrl + '/api/Default/DownloadPicture',
            userPrefCheck: environment.apiUrl + '/api/Default/UserPrefCheck',
            userPreferences: environment.apiUrl + '/api/UserPreferences/GetUserPreferences'
        },
        // tüketim özeti;
        consumptionSummary: {
            getEnergyTypeListByFacility: environment.apiUrl + '/api/PowerConsumption/GetEnergyTypeListByFacility',
            getConsumptionByFacility: environment.apiUrl + '/api/PowerConsumption/GetConsumptionByFacility',
            getConsumptionByFacilityResource: environment.apiUrl + '/api/PowerConsumption/GetConsumptionByFacilityResource',
            getFacilityResourcesTree: environment.apiUrl + '/api/PowerConsumption/GetFacilityResourcesTree',
            getConsumptionManuel: environment.apiUrl + '/api/PowerConsumption/GetConsumptionManuel',
            getEnergyTypeColumnPreference: environment.apiUrl + '/api/PowerConsumption/ManuelConsumptionColumnPreferences',
            setOriginalConsumptionManuel: environment.apiUrl + '/api/PowerConsumption/SetOriginalConsumptionManuel',
            setConsumptionManuel: environment.apiUrl + '/api/PowerConsumption/SetConsumptionManuel',
            getPowerConsumptionExcel: environment.apiUrl + '/api/PowerConsumption/GetPowerConsumptionExcel'
        },
        // tesismlerim;
        facilities: {
            getFacilities: environment.apiUrl + '/api/MyFacilities/GetFacilities',
            getFacilityNames: environment.apiUrl + '/api/Default/GetFacilityNames'
        },
        // kullanıcılar
        users: {
            getUserInfo: environment.apiUrl + '/api/MyInfo/GetUserInfo'
        },
        // olay kayıtları
        eventLogs: {
            getHardwareEventLogs: environment.apiUrl + '/api/MyDevices/GetHardwareEventLogs',
            importExcelEventLogs: environment.apiUrl + '/api/MyDevices/GetEventLogExcel'
        },
        // sayaç endeksleri
        meterIndices: {
            getFacilityMeterIndices: environment.apiUrl + '/api/PowerConsumption/GetFacilityMeterIndices',
            importExcelMeterIndices: environment.apiUrl + '/api/PowerConsumption/GetMeterIndicesExcel',
        },

        // products (ürünlerim) servileri
        products: {
            // Organizasyona ait ürünleri getiren metot
            getProducts: environment.apiUrl + '/api/Products/GetProducts',
            // İlgili tesise ait belirtilen yıl içerisindeki haftaların durumunu(yeşil/kırmızı) belirleyen metot.
            getFacilityProductStatus: environment.apiUrl + '/api/Products/GetFacilityProductStatus',
            // kaydet
            saveProduct: environment.apiUrl + '/api/Products/SaveProduct',
            // sil
            deleteProduct: environment.apiUrl + '/api/Products/DeleteProduct',
            // Tesise ait products yük ağacını getirir.
            getProductsFacilityResourcesTree: environment.apiUrl + '/api/Products/GetProductsFacilityResourcesTree',
            // Tesise ait tanımlanmış ürün detay verisi getirir
            getFacilityResourceProductDetails: environment.apiUrl + '/api/Products/GetFacilityResourceProductDetails',
            // Tesise ait ürün detay verilerin kayıt edilmesi
            saveFacilityResourceProductDetails: environment.apiUrl + '/api/Products/SaveFacilityResourceProductDetails',

            // Tesise ait ürün detay verisi silinmesi
            removeFacilityResourceProductDetail: environment.apiUrl + '/api/Products/RemoveFacilityResourceProductDetail',

            // Organizasyonun çalışma günlerini döndürür.
            getOrganizationWorkingDay: environment.apiUrl + '/api/Products/GetOrganizationWorkingDay',
        },

        // haritalar
        maps: {
            notificationsFromMessageCenter: environment.apiUrl + '/api/Map/GetNotificationsFromMessageCenter'
        }
    }
};
